export const EMBEDDED_MODE_QUERY = {
  EMBEDDED: 'embedded',
  EMBEDDED_VALUE: '1',
  MODE: 'mode',
  DETACHED_VALUE: 'detached',
} as const;

let detachedMode = false;

const getQueryParameter = (name: string): string | null => {
  if (typeof window === 'undefined') {
    return null;
  }

  return new URLSearchParams(window.location.search).get(name);
};

export const isEmbeddedIframe = (): boolean => {
  if (typeof window === 'undefined') {
    return false;
  }

  try {
    return window.parent !== window;
  } catch {
    return true;
  }
};

export const isEmbeddedQueryRequested = (): boolean =>
  getQueryParameter(EMBEDDED_MODE_QUERY.EMBEDDED) ===
  EMBEDDED_MODE_QUERY.EMBEDDED_VALUE;

export const isDetachedMode = (): boolean =>
  detachedMode ||
  getQueryParameter(EMBEDDED_MODE_QUERY.MODE) ===
    EMBEDDED_MODE_QUERY.DETACHED_VALUE;

/** True when game-window runs inside the lobby embed iframe. */
export const isEmbeddedInLobby = (): boolean =>
  !isDetachedMode() && isEmbeddedQueryRequested() && isEmbeddedIframe();

export const setDetachedMode = (value: boolean): void => {
  detachedMode = value;
};

/** @internal */
export const resetEmbeddedModeForTests = (): void => {
  detachedMode = false;
};
